module.exports = __webpack_public_path__ + "img/199.6c80caaf.jpg";